import KyeFieldSettings from './field-settings'
import './field-settings.scss'

export default KyeFieldSettings



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/index.js